import createLucideIcon from '../createLucideIcon';

/**
 * @component @name SlidersHorizontal
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgNUgzIiAvPgogIDxwYXRoIGQ9Ik0xMiAxOUgzIiAvPgogIDxwYXRoIGQ9Ik0xNCAzdjQiIC8+CiAgPHBhdGggZD0iTTE2IDE3djQiIC8+CiAgPHBhdGggZD0iTTIxIDEyaC05IiAvPgogIDxwYXRoIGQ9Ik0yMSAxOWgtNSIgLz4KICA8cGF0aCBkPSJNMjEgNWgtNyIgLz4KICA8cGF0aCBkPSJNOCAxMHY0IiAvPgogIDxwYXRoIGQ9Ik04IDEySDMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/sliders-horizontal
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SlidersHorizontal = createLucideIcon('sliders-horizontal', [
  ['path', { d: 'M10 5H3', key: '1qgfaw' }],
  ['path', { d: 'M12 19H3', key: 'yhmn1j' }],
  ['path', { d: 'M14 3v4', key: '1sua03' }],
  ['path', { d: 'M16 17v4', key: '1q0r14' }],
  ['path', { d: 'M21 12h-9', key: '1o4lsq' }],
  ['path', { d: 'M21 19h-5', key: '1rlt1p' }],
  ['path', { d: 'M21 5h-7', key: '1oszz2' }],
  ['path', { d: 'M8 10v4', key: 'tgpxqk' }],
  ['path', { d: 'M8 12H3', key: 'a7s4jb' }],
]);

export default SlidersHorizontal;
